import React from "react";
import Button from "@material-ui/core/Button";
import AuthForm from "./AuthForm";
import {useTranslation} from "react-i18next";
import {Box, Container, Divider} from "@material-ui/core";
import {AUTH_PAGE_PATH} from "../../layouts/navigation/Navigator";
import {useNavigate} from "react-router-dom";
import {AUTH_PAGE_MENU} from "../../pages/AuthPage";

type AuthPageButtonProps = {
    caption: string,
    linkTo: string
}

const AuthPageButton: React.FC<AuthPageButtonProps> = ({caption, linkTo}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <Box my={2}>
            <Button fullWidth color={"primary"} variant={"contained"}
                    onClick={() => navigate({
                        pathname: AUTH_PAGE_PATH,
                        search: "menu=" + linkTo
                    })}>{t(caption)}</Button>
        </Box>
    )
};

const AuthPageComponents: React.FC = () => {

    return (
        <Container maxWidth={"xs"}>
            <AuthForm/>

            <Box m={3}>
                <Divider/>
            </Box>

            <AuthPageButton caption={"buttons.reset-password"} linkTo={AUTH_PAGE_MENU.RESET_PASSWORD}/>
            <AuthPageButton caption={"buttons.register"} linkTo={AUTH_PAGE_MENU.REGISTER}/>
            <AuthPageButton caption={"buttons.terms-and-conditions"} linkTo={AUTH_PAGE_MENU.TERMS_AND_CONDITIONS}/>

        </Container>

    );
};

export default AuthPageComponents;